import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetStatuses } from "../../../store/status-store/status-actions";
import { statusActions } from "../../../store/status-store/status-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";

const StatusHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const status = useSelector((state) => state.status);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("status.showAll")
    ) {
      dispatch(GetStatuses(userInfo.Email));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("status.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const viewDetailHanlder = (val) => {
    navigate(`/status/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/status/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      statusActions.setStatus({
        status: {
          id: 0,
          name: "",
          description: "",
          code: "",
          color: "",
          status: false,
        },
      })
    );
    navigate(`/status/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("status.edit")
    ) {
      buttons.push(buttonEdit);
    }
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("status.view")
    ) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "color",
      header: "Color",
      filterMatchMode: "contains",
      body: (rowData) => {
        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: rowData.color,
              borderRadius: "5px",
            }}
          >
            <span style={{ color: rowData.color }}>.</span>
          </div>
        );
      },
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="40%"
          height="100vh"
          title="Estados"
          values={status.statuses}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "status.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default StatusHomePage;
